// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-main[data-v-22c41bb7]{background-color:#162b3a}.el-main .el-row[data-v-22c41bb7]{height:100%;flex-direction:column}", ""]);
// Exports
module.exports = exports;
